import type { ScreenModule } from "../../../app/screen-module";
import { ProductSettingsPage } from "../pages";

export default {
	id: "system-admin.settings",
	path: "/system/settings",
	area: "system-admin",
	navGroup: "コンテンツ",
	label: "製品設定",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: ProductSettingsPage,
} satisfies ScreenModule;
